import { CurrencyCode } from "../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../Wrap/Core/DataTypes/Money";
import { CurrencySymbolDictionary } from "../Html/Resources/CurrencySymbolDictionary";

export class MoneyDisplayHelper {
    public static FromatMoneyDisplay(
        Amount: number,
        Currency?: CurrencyCode,
        isShowCurrency?: boolean,
        decimalCount?: number
    ) {
        let symbol = "";
        const _isShowCurrency = isShowCurrency === false ? false : true;
        const _decimalCount = decimalCount ? decimalCount : 2;
        const _amonut = Amount ? Amount : 0;

        if (Currency && _isShowCurrency) {
            symbol = CurrencySymbolDictionary.getSymbol(Currency);
        }

        return symbol + `${_amonut.toFixed(_decimalCount).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}`;
    }

    public static getMoneyFormat(val: Money, isShowCurrency?: boolean, decimalCount?: number): string {
        if (!val) {return MoneyDisplayHelper.FromatMoneyDisplay(0, CurrencyCode.GBP, isShowCurrency, decimalCount);}
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(
            Math.abs(val.Amount),
            val.Currency || CurrencyCode.GBP,
            isShowCurrency,
            decimalCount
        );
        if (val.Amount < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    }

    public static getMoneyFormatWithEmpty(
        val: Money,
        emptyStr: string,
        emptyIncludeZero: boolean,
        isShowCurrency?: boolean,
        decimalCount?: number
    ): string {
        if (!val || (val.Amount === 0 && emptyIncludeZero)) {return emptyStr;}
        return this.getMoneyFormat(val, isShowCurrency, decimalCount);
    }

    public static getMoneyFormatNoSymbol(Amount: number, decimalCount?: number) {
        const _decimalCount = decimalCount ? decimalCount : 2;
        const _amonut = Amount ? Amount : 0;
        return Number(`${_amonut.toFixed(_decimalCount)}`);
    }

    public static getPercentageFormat(val: number, decimalCount = 2): string {
        return val.toFixed(decimalCount) + "%";
    }
}
